import { useState } from "react";
import { faHouseUser } from "@fortawesome/free-solid-svg-icons";
import { Content, PaginationTableFilter, PaginationTable, ButtonLink } from "@webtypen/react-components";
import { Page } from "../../components/Page";

export const CustomersOverview = () => {
    const [filter, setFilter] = useState({});

    return (
        <Page
            icon={faHouseUser}
            title="Kunden"
            actions={[<ButtonLink to="/customers/new/edit">Kunden anlegen</ButtonLink>]}
        >
            <Content>
                <PaginationTableFilter
                    definition={{
                        name: { type: "text", label: "Name" },
                        number: { type: "text", label: "Kundennummer" },
                    }}
                    filter={filter}
                    setFilter={setFilter}
                />
                <PaginationTable
                    url="/api/customers/list"
                    tableAttributes={{ className: "valign-middle" }}
                    payload={{ filter: filter }}
                    columns={[
                        { label: "Kurzname", attributes: { style: { width: 120 } } },
                        { label: "Name" },
                        { label: "Kundennummer", attributes: { style: { width: 120 } } },
                        { label: "Optionen", attributes: { className: "text-right", width: 130 } },
                    ]}
                    render={(row, i) => (
                        <tr key={i}>
                            <td>{row.short_name ? row.short_name : "-"}</td>
                            <td>{row.name}</td>
                            <td>{row.number ? row.number : "-"}</td>
                            <td className="text-right">
                                <ButtonLink to={"/customers/" + row._id + "/edit"} sm>
                                    Bearbeiten
                                </ButtonLink>
                            </td>
                        </tr>
                    )}
                />
            </Content>
        </Page>
    );
};
